// removed by extract-text-webpack-plugin
module.exports = {"SideDrawerCloseButton":"SideDrawerCloseButton__-loca-__1tN0X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/SideDrawerCloseButton/SideDrawerCloseButton.css
// module id = 119
// module chunks = 0